import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";

@Component({
	selector: "app-customer-summary",
	templateUrl: "./customer-summary.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerSummaryComponent implements OnInit {
	constructor(public app: AppService, public customerService: CustomerService) {}

	ngOnInit(): void {}
}
